import { render, staticRenderFns } from "./sewageMonitor.vue?vue&type=template&id=1934f06c&scoped=true&"
import script from "./sewageMonitor.vue?vue&type=script&lang=js&"
export * from "./sewageMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934f06c",
  null
  
)

export default component.exports